/*
  Lisen – "Visning: Standard / Packshots" (Lones idé, Claude 22. sep. 2026)

  1. KOLLEKTIONSSIDERNE. En kunde, der skimmer 200 jakker, bliver brændt af,
     at hvert billede er fotograferet forskelligt: model på gaden,
     miljøbillede, studie, packshot. Knappen ved siden af "Filtrer" slår hele
     gitteret over på ét udtryk – kun varen, samme baggrund – og tilbage igen.

  2. "MERE I SAMME SERIE" under produktsiden kører ALTID på packshots og har
     ingen knap. Rækken viser den samme model i flere udgaver, og modelfotos
     er direkte i vejen. Mærkes data-lisen-altid-pack i
     snippets/related-products-grid.liquid. "Samme vare i andre farver"
     røres ikke – dér ER varen den samme.

  HOVER VISER VARENS EGET FØRSTE BILLEDE (Lone, 22. sep. 2026)

  Første version skjulte hover-billedet i packshot-visning. To ting talte
  imod. Findify tegner sit eget hover-billede i et ekstra <img> med klassen
  findify-components-common--image__next, som CSS'en ikke kendte – så på
  Findify-siderne, altså næsten alle kollektioner, skiftede kortene alligevel
  ved hover, tit til en anden farve. Og et kort, hvor der slet ikke sker
  noget, mister den ene måde kunden kan se varen rigtigt på uden at klikke.

  Reglen er nu: er packshots valgt, viser hover varens FØRSTE billede – det,
  kortet ville have vist i Standard. Packshot til at skimme med, det rigtige
  foto når hun standser op. På halvdelen af varerne ER packshottet det
  første billede, og så sker der ingenting ved hover. Det er meningen.

  Farvepletterne på kortet røres ikke: de bliver ved med at vise packshots i
  packshot-visning, så udtrykket holder, når kunden klikker gennem farverne.

  ADRESSEN KAN BESTEMME VISNINGEN (Lone, 22. sep. 2026)

    /collections/jakker?visning=packshots
    /collections/jakker?visning=standard

  Så kan et nyhedsbrev linke direkte til packshot-visningen. Parameteren
  vinder over det, kunden måtte have valgt før, OG den gemmes – så visningen
  følger med, når hun klikker videre. Uden den gemmen ville et forsøg kun
  måle landingssiden og ikke resten af besøget.

  Bemærk om test: ét link i ét nyhedsbrev er ikke et split-test, for så
  sammenlignes de, der klikkede, med alle andre. Skal det måles ordentligt,
  skal listen deles i to, og de to halvdele have hver sin version af linket
  – med hver sin utm-mærkning, så de kan skilles ad bagefter.

  TRE VÆRKTØJSLINJER, IKKE ÉN (Lone, 22. sep. 2026)

  Knappen skal kunne sidde tre steder, og pladsen() vælger i den rækkefølge:

    1. Findify på computer  – …search--desktop-actions__block-inner
    2. Findify på mobil     – …search--mobile-actions
    3. Temaets egen linje   – .collection-filter, foran sorteringen

  Findify tegner IKKE den samme linje på de to skærmstørrelser: på mobil
  hedder den mobile-actions og er en kolonne med to kasser, RELEVANS og
  FILTRE. Slot nr. 1 hedder ligefrem "desktop", og derfor manglede knappen
  helt på mobil i første version – mens packshot-visningen fulgte med fra
  computeren og ikke kunne slås fra. Knappen lægges nu ind som en linje for
  sig under de to kasser; der er 341 px at dele, og tre kasser i række ville
  kun have plads til værdien uden ordet "Visning".

  Temaets linje står i HTML'en også på Findify-siderne – skjult, men der –
  og findes et øjeblik før Findifys. Derfor bygger byg() kun ÉN knap og
  FLYTTER den hen i den linje, siden bruger nu. Byggede den bare løs, ville
  der stå to, og den ene et sted kunden aldrig ser.

  FORMEN er valgt af Lone: en tekstknap. En variant med to ikonknapper
  (person / bøjle) blev bygget til sammenligning og fjernet igen.

  HVOR DATAEN KOMMER FRA. Metafeltet custom.packshot_url. Målt 22. sep. 2026
  på 1.250 aktive varer i fem brands: 1.224 har den (98 %). Kortene henter i
  forvejen data fra ?view=lisen-vendor, men den fil hentes for HVERT kort til
  HVER kunde, mens packshottet kun skal bruges af dem, der trykker på
  knappen. Derfor et eget, lille kald til ?view=lisen-pack, gemt i
  sessionStorage. Temaets egne kort får adressen med fra Liquid i
  data-lisen-pack og slipper for kaldet.

  FEM FÆLDER, alle fundet ved at prøve den af på rigtige sider:

  1) SVARET ER IKKE NØDVENDIGVIS EN ADRESSE. Skrives metafeltet igennem
     Liquids json-filter uden .value, svarer Shopify
     {"pack":{"error":"json not allowed for this object"}} – gyldig JSON,
     ingen fejl nogen steder, billederne skiftede bare ikke. Derfor tages
     svaret kun for gode varer, hvis det er en streng, der begynder med http.

  2) FINDIFY GENBRUGER KORT-ELEMENTER. Tegner den gitteret om, mens et svar
     er undervejs, peger det gamle kort-element nu på en ANDEN vare. Derfor
     huskes varens handle på hvert element, og alt kasseres, hvis kortet er
     skiftet vare undervejs.

  3) TEMAETS KORT VISER SLET IKKE ET <img>. Billedet er en BAGGRUND på
     .grid__image-ratio, som lazysizes styrer via data-bgset. Inde i kortet
     findes også et <img class="lazyautosizes"> – lazysizes' egen, usynlige
     måler. Sætter man packshottet på DEN, sker der ingenting, og man kan
     måle sig frem til, at alt er i orden, mens siden viser noget andet.
     Hover-billedet er samme slags: en div med data-bgset.

  4) "DET OPRINDELIGE BILLEDE" FINDES MÅSKE IKKE ENDNU. Lander kunden på en
     side med packshots allerede valgt, sættes packshottet på, før lazysizes
     har malet temaets eget billede. Det, vi gemmer som "det oprindelige",
     er derfor tomt – og trykker hun så Standard, bliver kortene helt tomme.
     At sætte data-bgset på igen hjælper ikke: lazysizes har mærket
     elementet lazyloaded og kigger ikke på det mere. Løsningen er at læse
     adresserne ud af data-bgset selv – se fraBgset(). Det er også den vej,
     hover-billedet finder "det første billede" at vise.

  5) ET FINDIFY-KORT LINKER IKKE TIL SIN EGEN VARE. De eneste /products/-
     links inde i kortet er farvepletterne, og den første af dem peger på en
     ANDEN farve – den nuværende er en span uden link. Spørger man bare om
     det første link, henter man altså nabofarvens packshot. På French
     Laundry ramte det 66 af 80 kort, og de sidste 14 havde slet intet link
     og fik ingenting. Den rigtige adresse ligger i Findifys React-data som
     item.product_url. Fremgangsmåden er kopieret fra
     assets/lisen-findify-cards.js, hvor den har virket siden kortene blev
     bygget om – se findifyVare() nedenfor. Reservevejen springer
     farvepletterne over, så den aldrig kan ramme forkert.
*/
(function () {
  'use strict';

  var FKORT = '.findify-components--cards--product';
  var TKORT = '.grid-product__content';
  var KORT = FKORT + ', ' + TKORT;
  var SLOT = '.findify-components-search--desktop-actions__block-inner';
  var MSLOT = '.findify-components-search--mobile-actions';
  var TSLOT = '.collection-filter__item--sort';
  var FHOVER = '.findify-components-common--image__next';
  var THOVER = '.grid-product__secondary-image';
  var VARELINK = 'a[href*="/products/"]:not(.lisen-card__farve)';
  var ALTID = '[data-lisen-altid-pack]';
  var NOEGLE = 'lisen-visning';
  var CACHE = 'lisen-pack-v2';
  var MAKS_PARALLEL = 6;

  // 1. hvad kunden valgte sidst
  var valgt = 'standard';
  try { if (localStorage.getItem(NOEGLE) === 'pack') valgt = 'pack'; } catch (e) {}

  // 2. … men adressen vinder, og den huskes, så den følger med videre
  var fraUrl = window.location.search.match(/[?&]visning=([^&#]+)/);
  if (fraUrl) {
    var v = decodeURIComponent(fraUrl[1]).toLowerCase();
    if (v === 'pack' || v === 'packshot' || v === 'packshots') valgt = 'pack';
    else if (v === 'standard' || v === 'normal') valgt = 'standard';
    try { localStorage.setItem(NOEGLE, valgt); } catch (e) {}
  }

  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE)) || {}; } catch (e) { cache = {}; }
  function gem() { try { sessionStorage.setItem(CACHE, JSON.stringify(cache)); } catch (e) {} }

  /* ---------- hvilken vare er kortet? ---------- */

  // Findifys egne data om kortet, hentet ud af React – se fælde 5.
  function findifyVare(kort) {
    try {
      var n = Object.keys(kort).filter(function (x) { return /^__reactFiber/.test(x); })[0];
      var f = n && kort[n];
      for (var d = 0; f && d < 20; d++, f = f.return) {
        var p = f.memoizedProps;
        if (p && p.item) return p.item;
      }
    } catch (e) {}
    return null;
  }

  function handleAf(kort) {
    var item = findifyVare(kort);
    var url = item ? (item.get ? item.get('product_url') : item.product_url) : '';
    if (!url) {
      var a = kort.querySelector(VARELINK);
      if (!a && kort.closest) a = kort.closest('a[href*="/products/"]');
      url = a ? a.getAttribute('href') : '';
    }
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ---------- packshot-adressen pr. vare ---------- */

  var venter = {};
  var koe = [];
  var aktive = 0;

  function pump() {
    while (aktive < MAKS_PARALLEL && koe.length) hent(koe.shift());
  }

  // Kun en rigtig adresse er et svar – se fælde 1 i toppen af filen.
  function somAdresse(vaerdi) {
    return (typeof vaerdi === 'string' && vaerdi.indexOf('http') === 0) ? vaerdi : '';
  }

  function hent(handle) {
    aktive++;
    fetch('/products/' + encodeURIComponent(handle) + '?view=lisen-pack', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var url = '';
        try { url = somAdresse((JSON.parse(t) || {}).pack); } catch (e) { url = ''; }
        cache[handle] = url;
        gem();
        return url;
      })
      .catch(function () { cache[handle] = ''; return ''; })
      .then(function (url) {
        aktive--;
        var cbs = venter[handle] || [];
        delete venter[handle];
        for (var i = 0; i < cbs.length; i++) cbs[i](url);
        pump();
      });
  }

  function packshot(handle, cb) {
    if (Object.prototype.hasOwnProperty.call(cache, handle)) { cb(somAdresse(cache[handle])); return; }
    if (venter[handle]) { venter[handle].push(cb); return; }
    venter[handle] = [cb];
    koe.push(handle);
    pump();
  }

  /* ---------- selve skiftet ---------- */

  // Rammen er temaets baggrundsvej. Findes den, er det DEN, kunden ser –
  // se fælde 3 i toppen af filen.
  function rammen(kort) {
    return kort.querySelector('.grid__image-ratio');
  }

  function billedet(kort) {
    if (rammen(kort)) return null;
    return kort.querySelector('.findify-components-common--image__image')
      || kort.querySelector('.grid-product__image')
      || kort.querySelector('img');
  }

  function bredde(el) {
    return ((el && el.clientWidth) || 400) * (window.devicePixelRatio || 1);
  }

  function medBredde(url, b) {
    if (!url) return url;
    var n = Math.min(1400, Math.max(300, Math.round(b || 500)));
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + n;
  }

  // Temaets eget billede, læst direkte ud af data-bgset – se fælde 4.
  // Listen ser ud som "//…_180x.jpg 180w, //…_360x.jpg 360w, …".
  // Vi tager den mindste, der er bred nok, og ellers den bredeste, vi har.
  function fraBgset(bgset, b) {
    if (!bgset) return '';
    var dele = bgset.split(',');
    var bedst = '', bedstW = -1, stoerst = '', stoerstW = -1;
    for (var i = 0; i < dele.length; i++) {
      var d = dele[i].replace(/^\s+|\s+$/g, '');
      if (!d) continue;
      var m = d.match(/^(\S+)(?:\s+(\d+)w)?/);
      if (!m) continue;
      var u = m[1];
      var w = m[2] ? parseInt(m[2], 10) : 0;
      if (w > stoerstW) { stoerstW = w; stoerst = u; }
      if (w >= b && (bedstW < 0 || w < bedstW)) { bedstW = w; bedst = u; }
    }
    return bedst || stoerst;
  }

  // Gemmer det oprindelige billede – men kun hvis det hører til den vare,
  // elementet viser NU. Genbruger Findify elementet til en anden vare, skal
  // den gamle original glemmes, ellers fører "tilbage til Standard" til et
  // billede af en helt tredje vare.
  function husk(el, handle, vaerdier) {
    if (el.getAttribute('data-lisen-for') === handle) return;
    el.setAttribute('data-lisen-for', handle);
    for (var n in vaerdier) {
      if (Object.prototype.hasOwnProperty.call(vaerdier, n)) el.setAttribute(n, vaerdier[n]);
    }
  }

  // Hvad elementet viste, før vi rodede med det – som en færdig url(…)-værdi.
  // Er den inline stil tom, blev den gemt for tidligt: se fælde 4.
  function detOprindelige(el) {
    var org = el.getAttribute('data-lisen-org') || '';
    if (org) return org;
    var u = fraBgset(el.getAttribute('data-lisen-orgbgset') || '', bredde(el));
    return u ? 'url("' + u + '")' : '';
  }

  // Hover på temaets kort: en div med data-bgset, samme slags som rammen.
  function hoverTema(kort, handle, foerste) {
    var sek = kort.querySelector(THOVER);
    if (!sek) return;
    husk(sek, handle, {
      'data-lisen-org': sek.style.backgroundImage || '',
      'data-lisen-orgbgset': sek.getAttribute('data-bgset') || ''
    });
    if (!foerste) return;
    sek.removeAttribute('data-bgset');
    sek.style.backgroundImage = foerste;
  }

  // Hover på Findifys kort: et ekstra <img>, der toner frem ovenpå.
  // Kender vi ikke varens første billede, viser vi packshottet igen – så
  // sker der ingenting ved hover, hvilket er bedre end et tilfældigt foto.
  function hoverFindify(kort, handle, foerste, pack) {
    var n = kort.querySelector(FHOVER);
    if (!n) return;
    husk(n, handle, {
      'data-lisen-org': n.getAttribute('src') || '',
      'data-lisen-orgset': n.getAttribute('srcset') || ''
    });
    n.removeAttribute('srcset');
    n.removeAttribute('data-srcset');
    n.setAttribute('src', foerste || medBredde(pack, bredde(n)));
  }

  function visPack(kort, handle, url) {
    if (!url) return;
    var ramme = rammen(kort);
    if (ramme) {
      husk(ramme, handle, {
        'data-lisen-org': ramme.style.backgroundImage || '',
        'data-lisen-orgbgset': ramme.getAttribute('data-bgset') || ''
      });
      var foerste = detOprindelige(ramme);
      // Uden det her skriver lazysizes modelfotoet tilbage bagefter
      ramme.removeAttribute('data-bgset');
      ramme.style.backgroundImage = 'url("' + medBredde(url, bredde(ramme)) + '")';
      hoverTema(kort, handle, foerste);
      return;
    }
    var img = billedet(kort);
    if (!img) return;
    husk(img, handle, {
      'data-lisen-org': img.getAttribute('src') || '',
      'data-lisen-orgset': img.getAttribute('srcset') || ''
    });
    var foersteSrc = img.getAttribute('data-lisen-org') || '';
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.setAttribute('src', medBredde(url, bredde(img)));
    hoverFindify(kort, handle, foersteSrc, url);
  }

  function gendanBaggrund(el, handle) {
    if (!el || el.getAttribute('data-lisen-for') !== handle) return;
    var bgset = el.getAttribute('data-lisen-orgbgset') || '';
    if (bgset) el.setAttribute('data-bgset', bgset);
    el.style.backgroundImage = detOprindelige(el);
  }

  function gendanImg(el, handle) {
    if (!el || el.getAttribute('data-lisen-for') !== handle) return;
    var org = el.getAttribute('data-lisen-org');
    var set = el.getAttribute('data-lisen-orgset');
    if (org) el.setAttribute('src', org);
    if (set) el.setAttribute('srcset', set); else el.removeAttribute('srcset');
  }

  function visStandard(kort) {
    var handle = handleAf(kort);
    var ramme = rammen(kort);
    if (ramme) {
      gendanBaggrund(ramme, handle);
      gendanBaggrund(kort.querySelector(THOVER), handle);
      return;
    }
    gendanImg(billedet(kort), handle);
    gendanImg(kort.querySelector(FHOVER), handle);
  }

  function skalHavePack(kort) {
    if (valgt === 'pack') return true;
    return !!(kort.closest && kort.closest(ALTID));
  }

  function opdater(kort) {
    if (!skalHavePack(kort)) { visStandard(kort); return; }
    var h = handleAf(kort);
    if (!h) return;
    // Temaets egne kort har adressen med fra Liquid – intet kald nødvendigt
    var fra = somAdresse(kort.getAttribute('data-lisen-pack'));
    if (fra) { visPack(kort, h, fra); return; }
    packshot(h, function (url) {
      if (!skalHavePack(kort)) return;
      if (handleAf(kort) !== h) return;
      visPack(kort, h, url);
    });
  }

  function opdaterAlle() {
    var kort = document.querySelectorAll(KORT);
    for (var i = 0; i < kort.length; i++) opdater(kort[i]);
    if (valgt === 'pack') document.documentElement.classList.add('lisen-visning-pack');
    else document.documentElement.classList.remove('lisen-visning-pack');
  }

  /* ---------- knappen ---------- */

  function navn() { return valgt === 'pack' ? 'Packshots' : 'Standard'; }

  function skiftTil(ny) {
    valgt = ny;
    try { localStorage.setItem(NOEGLE, ny); } catch (e) {}
    tegnOm();
    opdaterAlle();
  }

  function tegnOm() {
    var v = document.querySelector('.lisen-visning__vaerdi');
    if (v) v.textContent = navn();
  }

  // Finder den linje, siden faktisk bruger – se "tre værktøjslinjer" i
  // toppen. Findify tegner kun én af sine to, så den, der findes, er den,
  // skærmen viser. Temaets egen er sidste udvej.
  function pladsen() {
    var f = document.querySelector(SLOT);
    if (f) return { hus: f, foer: null };
    var m = document.querySelector(MSLOT);
    if (m) return { hus: m, foer: null };
    var sort = document.querySelector(TSLOT);
    if (sort && sort.parentNode) return { hus: sort.parentNode, foer: sort };
    return null;
  }

  function saetInd(boks, plads) {
    if (plads.foer) plads.hus.insertBefore(boks, plads.foer);
    else plads.hus.appendChild(boks);
  }

  function byg() {
    var plads = pladsen();
    if (!plads) return;

    // Der er kun én knap. Findes den allerede, flyttes den bare derhen,
    // hvor linjen er nu – se forklaringen i toppen af filen.
    var findes = document.querySelector('.lisen-visning');
    if (findes) {
      if (findes.parentNode !== plads.hus) saetInd(findes, plads);
      return;
    }

    var boks = document.createElement('span');
    boks.className = 'lisen-visning';

    var knap = document.createElement('button');
    knap.type = 'button';
    knap.className = 'lisen-visning__tekst';
    knap.innerHTML = '<span class="lisen-visning__ledetekst">Visning:</span>' +
      '<span class="lisen-visning__vaerdi"></span>';
    knap.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      skiftTil(valgt === 'pack' ? 'standard' : 'pack');
    });
    boks.appendChild(knap);

    saetInd(boks, plads);
    tegnOm();
  }

  /* ---------- kørsel ---------- */

  var planlagt = false;
  function koer() {
    planlagt = false;
    byg();
    opdaterAlle();
  }
  function planlaeg() {
    if (planlagt) return;
    planlagt = true;
    var g = function () { if (planlagt) koer(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(g);
    setTimeout(g, 150);
  }

  function start() {
    koer();
    new MutationObserver(planlaeg).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
